import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Tab, Tabs } from '@chilecompra/react-kit/components'
import { REACT_APP_ALLBUYERS_URL, REACT_APP_TCHC_BLOB_URL } from '../../config/settings/environment'
import {
  DialogDescription,
  DialogField,
  DialogItem,
  DialogLink,
  DialogList,
  DialogText,
  DialogTitle,
  GridContainer,
  GridItem,
  Italic,
  Strong
} from './DownloadOrdersAndBiddingsSection.styles'

/**
 * The BuildDialog's component.
 */
const BuildDialog = props => {
  const { open, origin, onClose } = props

  return (
    <Dialog maxWidth="800px" open={open} onClose={onClose}>
      <GridContainer padding="32px 4px 16px">
        <GridItem xs={12}>
          {origin === 'massive' && <DialogTitle>Descarga masiva a través de una URL</DialogTitle>}
          {origin === 'reports' && <DialogTitle>Descargar a través de una URL</DialogTitle>}
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 4px 20px">
        <GridItem xs={12}>
          {origin === 'massive' && (
            <DialogDescription>
              Las URLs de descargas se construyen específicamente para descargar de forma masiva órdenes de compra y
              licitaciones.
            </DialogDescription>
          )}
          {origin === 'reports' && (
            <DialogDescription>
              Las URLs de descargas se construyen específicamente para descargar órdenes de compra ya sean de organismos
              compradores, sectores del Estado o por el tamaño de empresa de los proveedores.
            </DialogDescription>
          )}
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 4px">
        <GridItem xs={12}>
          {origin === 'massive' && (
            <Tabs value="orders">
              <Tab id="orders" label="órdenes de compra">
                <GridContainer padding="0 0 20px">
                  <GridItem align="center" xs={12}>
                    <DialogField>
                      {REACT_APP_TCHC_BLOB_URL}/<Strong>oc-da</Strong>/<Strong>[año]</Strong>-<Strong>[mes]</Strong>.zip
                    </DialogField>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 14px">
                  <GridItem xs={12}>
                    <DialogText>
                      Como ejemplo, si deseas descargar las órdenes de compra de agosto del 2016, la URL sería la
                      siguiente:
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12}>
                    <DialogText>
                      <Strong>{REACT_APP_TCHC_BLOB_URL}/oc-da/2016-8.zip</Strong>
                    </DialogText>
                  </GridItem>
                </GridContainer>
              </Tab>
              <Tab id="biddings" label="licitaciones">
                <GridContainer padding="0 0 20px">
                  <GridItem align="center" xs={12}>
                    <DialogField>
                      {REACT_APP_TCHC_BLOB_URL}/<Strong>lic-da</Strong>/<Strong>[año]</Strong>-<Strong>[mes]</Strong>
                      .zip
                    </DialogField>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 14px">
                  <GridItem xs={12}>
                    <DialogText>
                      Como ejemplo, si deseas descargar las licitaciones de julio del 2015, la URL sería la siguiente:
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12}>
                    <DialogText>
                      <Strong>{REACT_APP_TCHC_BLOB_URL}/lic-da/2015-7.zip</Strong>
                    </DialogText>
                  </GridItem>
                </GridContainer>
              </Tab>
            </Tabs>
          )}
          {origin === 'reports' && (
            <Tabs value="buyers">
              <Tab id="buyers" label="org. compradores">
                <GridContainer padding="0 0 20px">
                  <GridItem align="center" xs={12}>
                    <DialogField>
                      https://<Strong>[NombreBucket]</Strong>.mercadopublico.cl/entcode/<Strong>[agno]</Strong>/
                      <Strong>[Sem1|Sem2]</Strong>/<Strong>[NombreArchivo]</Strong>.7z
                    </DialogField>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 19px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreBucket]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>
                      Se reemplaza dependiendo si desean descargar órdenes de compra o licitaciones:
                    </DialogText>
                    <br />
                    <br />
                    <DialogList>
                      <DialogItem>“chc-oc-files” para órdenes de compra</DialogItem>
                      <DialogItem>“chc-lic-files” para licitaciones</DialogItem>
                    </DialogList>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[agno]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se reemplaza con el año que se desea consultar
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[Sem1|Sem2]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se utiliza <Strong>Sem1</Strong> para consultar desde enero a junio o <Strong>Sem2</Strong> para
                    consultar desde julio a diciembre
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreArchivo]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>Se utiliza el entCode le organismo comprador a consultar.</DialogText>
                    <br />
                    <DialogText>
                      <Italic>
                        Puedes revisar los entCode de cada organismo comprador{' '}
                        <DialogLink target="_blank" href={REACT_APP_ALLBUYERS_URL}>
                          aquí
                        </DialogLink>
                      </Italic>
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 60px 13px" spacing={2}>
                  <GridItem xs={12}>
                    <DialogText>
                      Como ejemplo, si deseas descargar las órdenes de compra de marzo de 2019 de la SUBSECRETARIA DEL
                      MINISTERIO DE HACIENDA, la URL sería la siguiente:
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer spacing={2}>
                  <GridItem align="center" xs={12}>
                    <DialogText>
                      <Strong>https://chc-oc-files.mercadopublico.cl/entcode/2019/Sem1/6943.7z</Strong>
                    </DialogText>
                  </GridItem>
                </GridContainer>
              </Tab>
              <Tab id="state-sector" label="sector del estado">
                <GridContainer padding="0 0 20px">
                  <GridItem align="center" xs={12}>
                    <DialogField>
                      https://<Strong>[NombreBucket]</Strong>.mercadopublico.cl/entcode/<Strong>[agno]</Strong>/
                      <Strong>[Sem1|Sem2]</Strong>/<Strong>[NombreArchivo]</Strong>.7z
                    </DialogField>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 19px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreBucket]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>
                      Se reemplaza dependiendo si desean descargar órdenes de compra o licitaciones:
                    </DialogText>
                    <br />
                    <br />
                    <DialogList>
                      <DialogItem>“chc-oc-files” para órdenes de compra</DialogItem>
                      <DialogItem>“chc-lic-files” para licitaciones</DialogItem>
                    </DialogList>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[agno]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se reemplaza con el año que se desea consultar
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[Sem1|Sem2]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se utiliza <Strong>Sem1</Strong> para consultar desde enero a junio o <Strong>Sem2</Strong> para
                    consultar desde julio a diciembre
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreArchivo]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>Se utiliza el nombre del sector a descargar, las opciones son:</DialogText>
                    <br />
                    <DialogText>
                      <Italic>FuerzasArmadas, Municipalidades, Salud, ObrasPublicas,</Italic>
                    </DialogText>
                    <br />
                    <DialogText>
                      <Italic>GobCentralUniversidades, LegislativoJudicial, Otros</Italic>
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 60px 13px" spacing={2}>
                  <GridItem xs={12}>
                    <DialogText>
                      Como ejemplo, si deseas descargar las órdenes de compra de agosto del 2014 del sector
                      municipalidades, la URL sería la siguiente:
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer spacing={2}>
                  <GridItem align="center" xs={12}>
                    <DialogText>
                      <Strong>https://chc-oc-files.mercadopublico.cl/sector/2014/Sem2/Municipalidades.7z</Strong>
                    </DialogText>
                  </GridItem>
                </GridContainer>
              </Tab>
              <Tab id="provider-size" label="tamaño de proveedor">
                <GridContainer padding="0 0 20px">
                  <GridItem align="center" xs={12}>
                    <DialogField>
                      https://<Strong>[NombreBucket]</Strong>.mercadopublico.cl/entcode/<Strong>[agno]</Strong>/
                      <Strong>[Sem1|Sem2]</Strong>/<Strong>[NombreArchivo]</Strong>.7z
                    </DialogField>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 19px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreBucket]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>
                      Se reemplaza dependiendo si desean descargar órdenes de compra o licitaciones:
                    </DialogText>
                    <br />
                    <br />
                    <DialogList>
                      <DialogItem>“chc-oc-files” para órdenes de compra</DialogItem>
                      <DialogItem>“chc-lic-files” para licitaciones</DialogItem>
                    </DialogList>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[agno]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se reemplaza con el año que se desea consultar
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[Sem1|Sem2]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    Se utiliza <Strong>Sem1</Strong> para consultar desde enero a junio o <Strong>Sem2</Strong> para
                    consultar desde julio a diciembre
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 0 16px" spacing={2}>
                  <GridItem align="right" xs={3}>
                    <DialogText>
                      <Strong>[NombreArchivo]:</Strong>
                    </DialogText>
                  </GridItem>
                  <GridItem align="left" xs={9}>
                    <DialogText>Se utiliza el tamaño de empresa que quieres descargar, las opciones son:</DialogText>
                    <br />
                    <DialogText>
                      <Italic>Grande, Mediana, Micro, Pequena o NoClasificado</Italic>
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer padding="0 60px 13px" spacing={2}>
                  <GridItem xs={12}>
                    <DialogText>
                      Como ejemplo, si deseas descargar las órdenes de compra de abril de 2016 de los proveedores
                      clasificados como micro empresa, la URL sería la siguiente:
                    </DialogText>
                  </GridItem>
                </GridContainer>
                <GridContainer spacing={2}>
                  <GridItem align="center" xs={12}>
                    <DialogText>
                      <Strong>https://chc-oc-files.mercadopublico.cl/tamano/2016/Sem1/Micro.7z</Strong>
                    </DialogText>
                  </GridItem>
                </GridContainer>
              </Tab>
            </Tabs>
          )}
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 4px">
        <GridItem align="center" padding="28px 0" xs={12}>
          <Button color="default" onClick={onClose}>
            Cerrar
          </Button>
        </GridItem>
      </GridContainer>
    </Dialog>
  )
}

BuildDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  origin: PropTypes.oneOf(['massive', 'reports']),
  onClose: PropTypes.func.isRequired
}

export default BuildDialog
